//dependencies
import React from "react";
import { injectIntl } from "react-intl";

//components/controls
import { Grid } from '@mui/material';
import Select from 'Components/Select';

const TimeSelector = (props) => {
  const { value, label, onChange } = props;
  const { messages } = props.intl;

  const handleOptions = (value) => {
    let times = [];
    switch (value) {
      case "minutes":
        for (let min = 0; min < 60; min += 1) {
          times.push({
            id: ('0' + min).slice(-2),
            label: ('0' + min).slice(-2)
          });
        }
        break;
      case "hours":
        times = [...Array(12).keys()].map(i => {
          return {
            id: i + 1,
            label: i + 1
          }
        });
        break;
      case "timeZone":
        times = [{ id: 'AM', label: 'AM' }, { id: 'PM', label: 'PM' }];
        break;
      default:
        break;
    }
    return times;
  }

  return (
    <Grid container direction={'row'}>
      <Grid
        container
        direction="row"
        alignItems="center"
        style={{ minWidth: "300px" }}
      >
        <Grid item sm={12} style={{ marginTop: 10 }}>
          <label>{label || ''}</label>
        </Grid>
        <Grid item sm={3}>
          <Select
            value={value.hours}
            onChange={(event) => { onChange({ ...value, hours: event.id }) }}
            id="timeInputDateTime"
            placeholder={value.hours}
            options={handleOptions('hours')}
            textField="label"
            valueField="id"
            required
            //icon={'unfold_more'}
            requiredMessage={messages['required_field']}
          />
        </Grid>
        <Grid item sm={1}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: 10 }}>
            <p style={{ textAlign: 'center', fontWeight: 900 }}> : </p>
          </div>
        </Grid>
        <Grid item sm={3}>
          <Select
            value={value.minutes}
            onChange={(event) => { onChange({ ...value, minutes: event.id }) }}
            id="timeInputDateTime"
            placeholder={value.minutes}
            options={handleOptions('minutes')}
            textField="label"
            valueField="id"
            required
            //icon={'unfold_more'}
            requiredMessage={messages['required_field']}
          />
        </Grid>
        <Grid item sm={3} style={{ paddingLeft: 10 }}>
          <Select
            value={value.timeZone}
            onChange={(event) => { onChange({ ...value, timeZone: event.id }) }}
            id="timeInputDateTime"
            placeholder={value.timeZone}
            options={handleOptions('timeZone')}
            textField="label"
            valueField="id"
            required
            //icon={'unfold_more'}
            requiredMessage={messages['required_field']}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default injectIntl(TimeSelector)